import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemeName = 'dark' | 'ocean';

interface ThemeState {
  current: ThemeName;
}

const getInitialTheme = (): ThemeName => {
  const saved = typeof window !== 'undefined' ? (window.localStorage.getItem('themeName') as ThemeName | null) : null;
  if (saved === 'ocean' || saved === 'dark') return saved;
  return 'dark';
};

const initialState: ThemeState = {
  current: getInitialTheme(),
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<ThemeName>) {
      state.current = action.payload;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('themeName', action.payload);
        document.documentElement.setAttribute('data-theme', action.payload);
      }
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;

